import _ from 'lodash';
import { GeneralRequest } from 'structured-requests';

export default class messageCtrl {
  constructor(
    Message,
    LedgerCollection,
    ngDialog,
    urlParser,
    MessageParser,
    NotificationsService,
    blConfirmService,
    $state,
    $sanitize,
    ClientSettings,
    User,
  ) {
    this.Message = Message;
    this.LedgerCollection = LedgerCollection;
    this.ngDialog = ngDialog;
    this.urlParser = urlParser;
    this.MessageParser = MessageParser;
    this.NotificationsService = NotificationsService;
    this.blConfirmService = blConfirmService;
    this.$state = $state;
    this.$sanitize = $sanitize;
    this.supportedServiceBubbles = {
      GeneralRequest,
    };
    this.clientId = User.getClientId();
    this.settings = new ClientSettings(this.clientId);
  }

  $onInit() {
    this.message = new this.Message(this.messageId);
    this.setDefaults();
  }

  setDefaults() {
    this.showEdit = false;
    this.showMobileIcon = this.isMessageMobile();

    this.message.$onSet(() => {
      if (this.isEventType('feed.receipt.created')) {
        this.documentIds = this.documentIdsFromEvents(this.events);
      }
    });
  }

  isMessageMobile() {
    const messageOrigin = this.message.context.eventSource.component;
    return this.showMessageSource && messageOrigin === 'messaging.mobile';
  }

  isEventType(eventName) {
    return this.message.name === eventName;
  }

  documentIdsFromEvents(events) {
    return events.map(e => e.assets[0].resourceId);
  }

  isBookkeeper() {
    return !!this.bookkeeperId && !!this.message.$isAuthor(this.bookkeeperId);
  }

  hasReadReceipt() {
    return !!this.bookkeeperId && !!this.message.hasReadReceipt();
  }

  isAssetType(name) {
    return _.find(this.message.assets, {
      assetType: 'payload',
      payloadName: name,
    });
  }

  getRawMessagePayload() {
    const asset = _.find(this.message.assets, {
      assetType: 'payload',
      payloadName: 'message',
    });
    return asset?.payload || '';
  }

  sentWithSms() {
    return this.message.sentWithSms();
  }

  openEditMessage() {
    this.editMessageInput = this.getRawMessagePayload();
    this.showEdit = true;
  }

  closeEditMessage() {
    this.showEdit = false;
  }

  putMessage() {
    if (!this.editMessageForm.$valid) {
      return;
    }

    const parsers = this.bookKeeperId ? [this.urlParser] : [];

    const { message } = this.MessageParser.parse(this.editMessageInput, parsers);

    if (!message) {
      return;
    }

    this.NotificationsService.loader({
      resolve: this.message.$put(message),
      loadingText: 'Saving...',
      successText: 'Updated.',
      failureText: 'Failed to save message.',
    })
      .then(() => this.closeEditMessage())
      .catch(() => this.editMessageForm.$setInvalid);
  }

  deleteMessage() {
    this.message.$delete();
  }

  getPayloadSnippet() {
    const asset = this.isAssetType('message');
    const payload = asset ? asset.payload : '';

    return payload.slice(0, 15);
  }

  showCopySuccessNotification() {
    this.NotificationsService.add('Message copied to clipboard.', { length: 3, type: 'success' });
  }

  showCopyErrorNotification() {
    this.NotificationsService.add('Failed to copy message.', { length: 3, type: 'error' });
  }
}
